import _get from 'lodash/get'
import { fromJS, Map } from 'immutable'
import {
  SET_OPTIMIZELY_FEATURE_FLAG,
  UPDATE_OPTIMIZELY_FEATURE_FLAG,
  SET_OPTIMIZELY_FEATURE_MOUNTED,
  SET_OPTIMIZELY_FEATURE_USER_ATTRIBUTE,
  SET_OPTIMIZELY_FEATURE_USER_DATA,
} from './actions'

export const initialState = fromJS({
  mounted: false,
  flags: {},
  user: {},
})

export default function reducer (state = initialState, action) {
  const type = _get(action, 'type', '')
  const payload = _get(action, 'payload', {})

  switch (type) {
    case SET_OPTIMIZELY_FEATURE_MOUNTED:
      return state.set('mounted', payload)
    case UPDATE_OPTIMIZELY_FEATURE_FLAG:
      return state.update('flags', Map(), (flags) => flags.mergeDeep(fromJS(payload)))
    case SET_OPTIMIZELY_FEATURE_USER_DATA:
    case SET_OPTIMIZELY_FEATURE_USER_ATTRIBUTE:
      return state.update('user', Map(), (user) => {
        return user.mergeDeep(payload)
      })
    case SET_OPTIMIZELY_FEATURE_FLAG:
      return state.update('flags', Map(), (flags) => {
        const flag = _get(payload, 'flag')
        const existing = flags.get(flag)
        if (Map.isMap(existing) && !existing.isEmpty()) {
          return flags
        }
        return flags.set(flag, Map())
      })
    default:
      return state
  }
}
